if (!window.CornerWebComponentsAPI) {
	// Queue extension for when API is ready
	window.CORNER_PENDING_EXTENDED_COMPONENTS =
		window.CORNER_PENDING_EXTENDED_COMPONENTS || [];
	window.CORNER_PENDING_EXTENDED_COMPONENTS.push(() => {
		window.CornerWebComponentsAPI.extendComponent(
			'CornerQtyControl',
			(Base) => {
				return class extends Base {
					renderQtyControl() {
						const customerTags =
							window?.corner?.sessionData?.customer?.tags || [];
						const cornerHideQty = customerTags.includes('wholesale');
						console.log('cornerHideQty', cornerHideQty);
						if (cornerHideQty) {
							return this
								.html`<p class=" text-sm md:text-base text-cowi-primary-type text-center font-bold " aria-label="Current Item Quantity" data-testid="corner-cowi-cart-item-qty-${this.index}">
               QTY : ${this.quantity}
            </p>`;
						}
						return super.render();
					}

					render() {
						if (!this.item) {
							return this.nothing;
						}
						return this.renderQtyControl();
					}
				};
			}
		);
	});
} else {
	// API already loaded, extend directly
	window.CornerWebComponentsAPI.whenReady().then((api) => {
		api.extendComponent('CornerQtyControl', (Base) => {
			return class extends Base {
				renderQtyControl() {
					const customerTags =
						window?.corner?.sessionData?.customer?.tags || [];
					const cornerHideQty = customerTags.includes('wholesale');
					console.log('cornerHideQty', cornerHideQty);
					if (cornerHideQty) {
						return this
							.html`<p class=" text-sm md:text-base text-cowi-primary-type text-center font-bold " aria-label="Current Item Quantity" data-testid="corner-cowi-cart-item-qty-${this.index}">
               QTY : ${this.quantity}
            </p>`;
					}
					return super.renderQtyControl();
				}
				render() {
					if (!this.item) {
						return this.nothing;
					}
					return this.renderQtyControl();
				}
			};
		});
	});
}
